import BlazeSlider from "blaze-slider";
import "blaze-slider/dist/blaze.css";

window.addEventListener("load", () => {
  const el = document.querySelector(".blaze-slider");

  if (el) {
    new BlazeSlider(el, {
      all: {
        slidesToShow: 1,
        autoplayInterval: 3000,
        transitionDuration: 600,
        loop: true,
        enableAutoplay: true,
        transitionTimingFunction: "cubic-bezier(0.46,0.03,0.52,0.96)",
      },
      "(min-width: 650px)": {
        slidesToShow: 2,
      },
      "(min-width: 950px)": {
        slidesToShow: 3,
      },
      "(min-width: 1400px)": {
        slidesToShow: 4,
      },
    });
  }
});
